import React from 'react';
import PropTypes from 'prop-types';

import { CenteredContainer, Title, Text, Button } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import CareersBreadcrumbs from './careers-breadcrumbs';

import styles from './hero.module.less';

const Hero = ({
  altText,
  backgroundColor,
  showCareerBreadcrumbs,
  careerBreadcrumbDepartment,
  careerBreadcrumbLevel,
  color,
  copy,
  ctaText,
  ctaUrl,
  imageUrlDesktop,
  imageUrlMobile,
  jobTitle,
  title,
}) => {
  const heroTopBackground = {
    backgroundColor: `${backgroundColor}`,
  };

  const heroTitleStyle = showCareerBreadcrumbs
    ? styles.heroTitleBreadCrumb
    : styles.heroTitle;

  const heroTextColor = {
    color: `${color}`,
  };

  const heroImageBackground = {
    backgroundImage: `linear-gradient(${backgroundColor} 50%, #ffffff 0%)`,
  };

  return (
    <React.Fragment>
      <div className={styles.heroTopContainer} style={heroTopBackground}>
        <CenteredContainer className={styles.heroTopCentered}>
          {showCareerBreadcrumbs && (
            <CareersBreadcrumbs
              level={careerBreadcrumbLevel}
              careerBreadcrumbDepartment={careerBreadcrumbDepartment}
              jobTitle={jobTitle}
            />
          )}
          <Title
            className={heroTitleStyle}
            style={heroTextColor}
            component="h1"
          >
            {title}
          </Title>
          <div className={styles.heroCopy} style={heroTextColor}>
            <Text>{copy}</Text>
          </div>
          {ctaUrl ? (
            <Button className={styles.heroButton} href={ctaUrl} primary>
              {ctaText}
            </Button>
          ) : null}
        </CenteredContainer>
      </div>
      <div
        className={styles.heroBottomImageContainer}
        style={heroImageBackground}
      >
        <CenteredContainer>
          <Image
            src={imageUrlMobile}
            alt={altText}
            backgroundColor="transparent"
            naturalWidth={684}
            naturalHeight={372}
            className={styles.heroImageMobile}
            lazy
          />
          <Image
            src={imageUrlDesktop}
            alt={altText}
            backgroundColor="transparent"
            naturalWidth={2304}
            naturalHeight={930}
            className={styles.heroImageDesktop}
            lazy
          />
        </CenteredContainer>
      </div>
    </React.Fragment>
  );
};

Hero.propTypes = {
  altText: PropTypes.string,
  backgroundColor: PropTypes.string,
  showCareerBreadcrumbs: PropTypes.bool,
  careerBreadcrumbDepartment: PropTypes.string,
  careerBreadcrumbLevel: PropTypes.string,
  color: PropTypes.string,
  copy: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  imageUrlDesktop: PropTypes.string,
  imageUrlMobile: PropTypes.string,
  jobTitle: PropTypes.string,
  title: PropTypes.string,
};

Hero.defaultProps = {
  showCareerBreadcrumbs: false,
  backgroundColor: '#EEF7FF',
};

Hero.displayName = 'Company Hero';

export default Hero;
